import React, { useContext, useEffect, useState } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getGreetingAccordingToTime, getTernaryValue } from 'common/utilities/utils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { Config, AFTER_NOON, ROUTE_URL } from 'common/constants/SharedConstants';
import { ButtonComp, ButtonType, ContainedButton } from 'atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import SignOutAccountInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { ACCOUNT_SETTINGS } from '../../AU/Constants/Constants';
import { UserOrderContext } from 'context/context';
import { useSelector } from 'react-redux';

const DeleteAccountConfirmModal = ({ handleClose, signOutAccount }) => {
  const { SIGN_OUT, CANCEL, SIGN_OUT_ACCOUNT_MESSAGE } = ACCOUNT_SETTINGS;
  const SIGN_OUT_CONSTANTS = {
    CONFIRM_SIGN_OUT_TEXT: {
      MSGTXT1: translateWithI18Next(SIGN_OUT_ACCOUNT_MESSAGE),
    },
  };

  return (
    <React.Fragment>
      <SignOutAccountInsideModel
        handleClose={handleClose}
        classNames='delete-account-modal'
        CartAlertForm={
          <AlertForm
            splitTitle={SIGN_OUT_CONSTANTS.CONFIRM_SIGN_OUT_TEXT}
            imageSrc={IMAGE_PATH.CartError}
            altText={'delete-account'}
            cancelButtonText={translateWithI18Next(CANCEL)}
            confirmButtonText={translateWithI18Next(SIGN_OUT)}
            confirmHandler={signOutAccount}
            cancelHandler={handleClose}
          />
        }
      />
    </React.Fragment>
  );
};

const AccountHeader = ({ currentMenu, updateMenu, signOutAccount, isMobile, basicData }) => {
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [messageCount, setMessageCount] = useState(0);
  const { userOrderState } = useContext(UserOrderContext);
  const {
    ADDRESS,
    ADDRESS_PLACEHOLDER,
    SIGN_OUT,
    GREETING_GOOD,
    KFC_LOVER,
    ORDER_HISTORY_TAG,
    FAVORITE_ORDERS,
    ACCOUNT_SETTING,
    MESSAGE_TAG,
    MY_PAYMENT_METHODS,
  } = TRANSLATE_MAPPING_KEY;
  const { accountCardLength } = userOrderState;
  const showMyPaymentMethods = useSelector(
    state => state.tenantReducer?.componentOptions?.web?.accountPage?.showMyPaymentMethods ?? '',
  );

  const handleClose = () => {
    setConfirmDialog(false);
  };
  useEffect(() => {
    setMessageCount(accountCardLength);
  }, [accountCardLength]);

  //We need the commented code for future
  const desktopAccountHeader = () => {
    return (
      <div
        className={`account-header-container ${getGreetingAccordingToTime() === AFTER_NOON && 'account-header-noon'}`}
      >
        <img alt='stripes' src={IMAGE_PATH.Strips} className='account-icon' />
        <h4 className='account-header'>
          {translateWithI18Next(`${translateWithI18Next(GREETING_GOOD)} ${getGreetingAccordingToTime()}`)}
        </h4>
        <h4 className='account-user-name'>
          {translateWithI18Next(`${basicData?.firstName || translateWithI18Next(KFC_LOVER)}!`)}
        </h4>
        <div className='account-menu-container'>
          <div
            data-testid='account-messages-testid'
            className={getTernaryValue(currentMenu === MESSAGE_TAG, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(MESSAGE_TAG)}
          >
            {translateWithI18Next(MESSAGE_TAG)}
            {!!messageCount && <span className='msg-badge'>{messageCount}</span>}
          </div>

          <div
            data-testid='order-history-testid'
            className={getTernaryValue(
              currentMenu === ROUTE_URL.ORDER_HISTORY,
              'activeMenu account-menu',
              'account-menu',
            )}
            onClick={() => updateMenu(ROUTE_URL.ORDER_HISTORY)}
          >
            {translateWithI18Next(ORDER_HISTORY_TAG)}
          </div>
          <div
            className={getTernaryValue(currentMenu === FAVORITE_ORDERS, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(FAVORITE_ORDERS)}
            data-testid='fav-menu-link'
          >
            {translateWithI18Next(FAVORITE_ORDERS)}
          </div>
          {showMyPaymentMethods && (
            <div
              data-testid='my-payment-methods-testid'
              className={getTernaryValue(currentMenu === MY_PAYMENT_METHODS, 'activeMenu account-menu', 'account-menu')}
              onClick={() => updateMenu(MY_PAYMENT_METHODS)}
            >
              {translateWithI18Next(MY_PAYMENT_METHODS)}
            </div>
          )}
          <div
            data-testid='saved-address-testid'
            className={getTernaryValue(currentMenu === ADDRESS, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(ADDRESS)}
          >
            {translateWithI18Next(ADDRESS_PLACEHOLDER)}
          </div>
          <div
            data-testid='account-settings-testid'
            className={getTernaryValue(currentMenu === ACCOUNT_SETTING, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(ACCOUNT_SETTING)}
          >
            {translateWithI18Next(ACCOUNT_SETTING)}
          </div>
        </div>
        <ContainedButton
          data-testId='signout-button1-testid'
          className={'sign-out-btn '}
          data-id={Config.HEADER_SIGN_IN_ATTR_DATA_ID}
          variant={ButtonType.tertiary}
          inverted
          small
          aria-label={''}
          type='submit'
          onClick={() => {
            setConfirmDialog(true);
          }}
        >
          <span data-testid='signout-button-testid'>{translateWithI18Next(SIGN_OUT)}</span>
        </ContainedButton>
        {confirmDialog && <DeleteAccountConfirmModal handleClose={handleClose} signOutAccount={signOutAccount} />}
      </div>
    );
  };

  const mobileAccountHeader = () => {
    return (
      <div className='account-mobile-container'>
        <div className='account-mobile-header'>
          <div className='account-header-container'>
            <img alt='arrow' src={IMAGE_PATH.Strips} className='account-icon' />
            <h4 className='account-header account-user-name-mobile'>
              {translateWithI18Next(
                `${translateWithI18Next(GREETING_GOOD)} ${getGreetingAccordingToTime()}  ${
                  basicData.firstName || basicData.phone
                }!`,
              )}
            </h4>
            <ButtonComp
              data-testid='signout-button1-testid'
              className='button transparent-btn white-border sign-out-btn sign-out-btn-au'
              aria-label={''}
              onClick={() => {
                setConfirmDialog(true);
              }}
              type='submit'
            >
              <span>{translateWithI18Next(SIGN_OUT)}</span>
            </ButtonComp>
            {confirmDialog && <DeleteAccountConfirmModal handleClose={handleClose} signOutAccount={signOutAccount} />}
          </div>
        </div>

        <div className='account-mobile-menu-option'>
          <section
            data-testid='account-messages-mobile-testid'
            onClick={() => updateMenu(MESSAGE_TAG)}
            className='account-accordian'
          >
            <div className='global-accordian-container'>
              <div className='global-accordian-header-container'>
                <span className='global-accordian-header'>{translateWithI18Next(MESSAGE_TAG)}</span>
                {!!messageCount && <span className='msg-badge'>{messageCount}</span>}
                <img alt='arrow' src={IMAGE_PATH.Arrow} className='account-icon' />
              </div>
            </div>
          </section>
          <section
            data-testid='order-history-mobile-testid'
            onClick={() => updateMenu(ROUTE_URL.ORDER_HISTORY)}
            className='account-accordian'
          >
            <div className='global-accordian-container'>
              <div className='global-accordian-header-container'>
                <span className='global-accordian-header'>{translateWithI18Next(ORDER_HISTORY_TAG)}</span>
                <img alt='arrow' src={IMAGE_PATH.Arrow} className='account-icon' />
              </div>
            </div>
          </section>
          <section
            data-testid='fav-menu-mobile-testid'
            onClick={() => updateMenu(FAVORITE_ORDERS)}
            className='account-accordian'
          >
            <div className='global-accordian-container'>
              <div className='global-accordian-header-container'>
                <span className='global-accordian-header'>{translateWithI18Next(FAVORITE_ORDERS)}</span>
                <img src={IMAGE_PATH.Arrow} className='account-icon' alt='Account Icon' />
              </div>
            </div>
          </section>
          {showMyPaymentMethods && (
            <section
              data-testid='my-payment-methods-mobile-testid'
              onClick={() => updateMenu(MY_PAYMENT_METHODS)}
              className='account-accordian'
            >
              <div className='global-accordian-container'>
                <div className='global-accordian-header-container'>
                  <span className='global-accordian-header'>{translateWithI18Next(MY_PAYMENT_METHODS)}</span>
                  <img src={IMAGE_PATH.Arrow} className='account-icon' alt='arrow-icon' />
                </div>
              </div>
            </section>
          )}
          <section
            data-testid='saved-address-mobile-testid'
            onClick={() => updateMenu(ADDRESS)}
            className='account-accordian'
          >
            <div className='global-accordian-container'>
              <div className='global-accordian-header-container'>
                <span className='global-accordian-header'>{translateWithI18Next(ADDRESS_PLACEHOLDER)}</span>
                <img alt='arrow' src={IMAGE_PATH.Arrow} className='account-icon' />
              </div>
            </div>
          </section>
          <section
            data-testid='account-settings-mobile-testid'
            onClick={() => updateMenu(ACCOUNT_SETTING)}
            className='account-accordian'
          >
            <div className='global-accordian-container'>
              <div className='global-accordian-header-container'>
                <span className='global-accordian-header'>{translateWithI18Next(ACCOUNT_SETTING)}</span>
                <img src={IMAGE_PATH.Arrow} className='account-icon' alt='' />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };

  return isMobile ? mobileAccountHeader() : desktopAccountHeader();
};

export default AccountHeader;
